/* aerobis embed auto-resize.
   Accepts {aerobisEmbed:<key>, height} only from https://static.aerobis.com and only for known keys.
   The target is the iframe whose contentWindow sent the message (falls back to #aerobis-<key>).
   Height is clamped to 120..8000 px. Tool embeds drop their fallback min-height once a real height arrives. */
(function () {
  var ORIGIN = "https://static.aerobis.com";
  var KEYS = { powrlink: 1, "sleep-window": 1, ffmi: 1 };
  function findFrame(src, key) {
    var frames = document.getElementsByTagName("iframe");
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].contentWindow === src) return frames[i];
    }
    return document.getElementById("aerobis-" + key);
  }
  window.addEventListener("message", function (ev) {
    if (ev.origin !== ORIGIN) return;
    var d = ev.data;
    if (!d || typeof d !== "object" || !KEYS.hasOwnProperty(d.aerobisEmbed)) return;
    var h = Math.round(Number(d.height));
    if (!isFinite(h)) return;
    if (h < 120) h = 120;
    if (h > 8000) h = 8000;
    var f = findFrame(ev.source, d.aerobisEmbed);
    if (!f) return;
    f.style.height = h + "px";
    if (d.aerobisEmbed !== "powrlink") f.style.minHeight = "0";
  });
})();
